/**
 * 裙星空间动态接口
 * - 动态列表 / 发布 / 浏览+1 / 点赞 / 删除
 * - 评论：分页列表 / 发表 / 回复 / 点赞 / 删除
 */
import request from './request'

/**
 * 动态列表（按时间倒序）
 * @param {number|null} userId 发布者用户ID，不传则返回全部
 * @param {string} [currentNo] 当前登录账号，用于返回"我是否已点赞"
 */
export function listMoments(userId, currentNo) {
  return request.get('/moment/list', { params: { userId, currentNo } })
}

/**
 * 发布动态
 * @param {{userId:number, userNo:string, userName:string, content:string, images:string}} data
 * images 为逗号分隔的上传路径
 */
export function saveMoment(data) {
  return request.post('/moment/save', data)
}

/**
 * 浏览 +1
 * @param {number} id 动态ID
 */
export function viewMoment(id) {
  return request.get('/moment/view', { params: { id } })
}

/**
 * 点赞 / 取消点赞（动态）
 * @param {{momentId:number, userId:number, userNo:string}} data
 */
export function likeMoment(data) {
  return request.post('/moment/like', data)
}

/**
 * 删除动态（超级管理员可删任意；发布者本人可删自己的）
 * @param {{id:number, operatorNo:string, operatorName:string, operatorRole:number}} data
 */
export function deleteMoment(data) {
  return request.get('/moment/del', { params: data })
}

/**
 * 某条动态的评论列表（分页，点赞多的排最前，回复随父评论返回）
 * @param {number} momentId
 * @param {number} [page]
 * @param {number} [size]
 * @param {string} [currentNo] 当前登录账号，用于返回"我是否已点赞"
 */
export function listComments(momentId, page = 1, size = 5, currentNo) {
  return request.get('/comment/list', { params: { momentId, page, size, currentNo } })
}

/**
 * 发表评论 / 回复评论
 * @param {{momentId:number, userId:number, userNo:string, userName:string, content:string,
 *          parentId?:number, replyUserName?:string}} data
 */
export function saveComment(data) {
  return request.post('/comment/save', data)
}

/**
 * 评论点赞 / 取消点赞
 * @param {{commentId:number, userId:number, userNo:string}} data
 */
export function likeComment(data) {
  return request.post('/comment/like', data)
}

/**
 * 删除评论（超级管理员可删任意；评论者本人可删自己的，父评论删除级联其回复）
 * @param {{id:number, operatorNo:string, operatorRole:number}} data
 */
export function deleteComment(data) {
  return request.get('/comment/del', { params: data })
}
